import React, { useState } from "react";
import { useWatchState, useModal } from "@/store";
import { checkResult } from "@/common";
import { checkPhone } from "@/check";
import { BaseService, CommonService } from "@/service";
import { Modal, Button, Input, message, Checkbox } from "antd";

const { Search } = Input;

const App = () => {

    const [protocolModal] = useModal(["protocol"]);

    const [[{ title, show, hide, width = 300, callback }]] = useWatchState(["modal.register"])
    const [protocol, setProtocol] = useState(false);
    const [code, setCode] = useState();
    const [msgId, setMsgId] = useState();
    const [account, setAccount] = useState();
    const [password, setPassword] = useState();
    const [againPassword, setAgainPassword] = useState();
    let [send, setSend] = useState();

    const isRegister = async () => {
        const res = await BaseService.list({
            table: "thtt_user",
            where: {
                account,
                is_delete: 0
            }
        })
        if (!checkResult(res)) return;
        const boo = Boolean(res.data.result.length);
        return boo;
    }

    const onSendCode = async () => {

        if (!account) return message.warn("请输入手机号");
        if (!checkPhone(account)) return message.error("请输入有效手机号！");

        const register = await isRegister();
        if (register) return message.warn("此账号已注册！");

        CommonService.code({
            phone: account,
            type: 1
        }).then(res => {
            if (!checkResult(res)) return;
            const msgId = res.data.result.msgId;
            if (!msgId) return message.error("消息发送错误！");
            setMsgId(msgId);
            message.success("发送成功！");
            time();
        }).catch(err => {
            message.error("验证发送失败，请稍后再试！");
            throw err;
        })
    }

    const time = () => {
        send = 60;
        setSend(send);
        const timer = setInterval(() => {
            if (send === 0) return clearInterval(timer)
            setSend(--send)
        }, 1000);
    }

    const onChangeProtocol = () => {
        setProtocol(!protocol)
    }

    const onRegister = () => {
        if (!password || !againPassword) return message.warn("请输入密码！");
        if (password !== againPassword) return message.warn("两次请输入密码不一致，请检查！");
        if (!protocol) return message.warn("请点击同意《天合育成》");
        if (!account) return message.warn("请输入手机号");
        if (!checkPhone(account)) return message.warn("请输入有效手机号！");
        if (!msgId) return message.error("消息发送错误！");

        CommonService.register({
            account,
            password,
            verificationCode: code,
            msgId
        }).then(res => {
            if (!checkResult(res)) return;
            message.success("注册成功！");
            hide();
        }).catch(err => {
            message.error("注册失败！");
            throw err;
        })
    }

    return (
        <Modal
            title={title}
            className="modal--no-title"
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose={true}
            onCancel={hide}
            footer={false}
        >
            <div className="child-top-sm">
                <Input type="account" onChange={setAccount.filterProps("target.value")} placeholder="请输入手机号" autoComplete="off" />
                <Search
                    onChange={setCode.filterProps("target.value")}
                    placeholder="请输入验证码"
                    enterButton={<span className="font-size-12">{send ? `${send}s` : "发送验证码"}</span>}
                    onSearch={onSendCode}
                    autoComplete="new-password"
                />
                <Input.Password onChange={setPassword.filterProps("target.value")} placeholder="请输入密码" autoComplete="new-password" />
                <Input.Password onChange={setAgainPassword.filterProps("target.value")} placeholder="请再次输入密码" autoComplete="new-password" />
                <Checkbox onChange={onChangeProtocol} className="font-size-12">我已阅读并同意<a onClick={protocolModal.show} className="font-size-12 link">《天合育成》</a></Checkbox>
                <Button onClick={onRegister} type="primary" block>注册</Button>
            </div>
        </Modal>
    );
}

export default App;